import Layout from '../../companyAdmin/layout.vue'
import Index from './index.vue'

const basePath = '/v-admin/client-admin/upload-data-management'

export default {
  path: `${basePath}`,
  redirect: `${basePath}/`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: ['PERM_ADMIN_UPLOAD_DATA'],
    menu: {
      labelI18nKey: 'admin.customer.uploadDataManagement.menu'
    }
  },
  children: [
    {
      path: `${basePath}/`,
      component: Index,
      meta: {
        breadcrumb: { hidden: true },
        isNewPage: true,
        titleI18nKey: 'admin.customer.uploadDataManagement.title'
      }
    }
  ]
}
